export enum TypesButton {
  FILL = 'fill',
  OUTLINE = 'outline',
  OUTLINE_BORDER = 'outline_border',
  OUTLINE_BORDER_GREY = 'outline_border_grey'
}
